import { render, staticRenderFns } from "./OtherCourses.vue?vue&type=template&id=3adae608&scoped=true"
import script from "./OtherCourses.vue?vue&type=script&lang=js"
export * from "./OtherCourses.vue?vue&type=script&lang=js"
import style0 from "./OtherCourses.vue?vue&type=style&index=0&id=3adae608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adae608",
  null
  
)

export default component.exports